import { AuthModel, AuthRequestModel, CommunityPathwayPayload } from "@tsin-core/models/auth.model";

const ACTION_SCOPE = '[Auth]';

export class AuthenticateAction {
  static readonly type = `${ACTION_SCOPE} Login`;
  constructor(public payload: AuthRequestModel) { }
}

export class LogoutAction {
  static readonly type = `${ACTION_SCOPE} Logout`;
}

export class SetLangAction{
  static readonly type = `${ACTION_SCOPE} Set Language`;
  constructor(public payload: 'en' | 'fr') {}
}

export class GetProfileAction {
  static readonly type = `${ACTION_SCOPE} Get Profile`;
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}

export class ValidateTokenAction {
  static readonly type = `${ACTION_SCOPE} Validate Token`;
  constructor(public payload: { token: string; refreshToken: string }) { }
}

export class RefreshTokenAction {
  static readonly type = `${ACTION_SCOPE} Refresh Token`;
  constructor(public payload: { refreshToken: string }) { }
}

/**
 * Directly set auth state from Cognito token exchange response.
 * Bypasses the PRO backend /user/me call so the auth guard passes immediately.
 */
export class SetAuthAction {
  static readonly type = `${ACTION_SCOPE} Set Auth`;
  constructor(public payload: { token: string; refreshToken: string | null; user: any }) { }
}

/** Refresh the saved practice option from /user/me so a returning applicant sees it pre-selected. */
export class LoadCommunityPathwayAction {
  static readonly type = `${ACTION_SCOPE} Load Community Pathway`;
}

/** Save the practice option chosen on the community-pathway page. */
export class SaveCommunityPathwayAction {
  static readonly type = `${ACTION_SCOPE} Save Community Pathway`;
  constructor(public payload: CommunityPathwayPayload) { }
}
